@if (isFasdac) {
  <div class="container-details">
    <div class="back-button" nz-col nzSpan="24" [routerLink]="backLink">
      <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
      {{ 'termsOfUseFasdac.back' | translate }}
    </div>
    <div class="header">
      <i></i>
      <p class="title">{{ 'termsOfUseFasdac.title' | translate }}</p>
    </div>
    <div class="content">
      <p class="title">{{ 'termsOfUseFasdac.pageTitle' | translate }}</p>
      <p class="subtitle">{{ 'termsOfUseFasdac.pageSubTitle' | translate }}</p>
      <div class="first-question">
        <p class="answer">{{ 'termsOfUseFasdac.firstQuestion.answer' | translate }}</p>
        <p class="question">{{ 'termsOfUseFasdac.firstQuestion.question' | translate }}</p>
        <div class="indented">
          <div>
            <p class="answer">{{ 'termsOfUseFasdac.firstQuestion.aAnswer' | translate }}</p>
            <p class="question">{{ 'termsOfUseFasdac.firstQuestion.aQuestion' | translate }}</p>
          </div>
          <div>
            <p class="answer">{{ 'termsOfUseFasdac.firstQuestion.bAnswer' | translate }}</p>
            <p class="question">{{ 'termsOfUseFasdac.firstQuestion.bQuestion' | translate }}</p>
          </div>
          <div>
            <p class="answer">{{ 'termsOfUseFasdac.firstQuestion.cAnswer' | translate }}</p>
            <p class="question">{{ 'termsOfUseFasdac.firstQuestion.cQuestion' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="second-question">
        <p class="answer">{{ 'termsOfUseFasdac.secondQuestion.answer' | translate }}</p>
        <p class="question indented">{{ 'termsOfUseFasdac.secondQuestion.question' | translate }}</p>
      </div>
      <div class="third-question">
        <p class="answer">{{ 'termsOfUseFasdac.thirdQuestion.answer' | translate }}</p>
        <div class="indented">
          @for (answer of thirdAnswer; track answer) {
            <p class="question">{{ answer }}</p>
          }
        </div>
      </div>
      @for (answer of answers; track answer) {
        <div>
          <p class="answer">{{ answer.answer }}</p>
          <p class="question indented">{{ answer.question }}</p>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="container-details">
    <div class="back-button" nz-col nzSpan="24" [routerLink]="backLink">
      <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
      {{ 'termsOfUse.back' | translate }}
    </div>
    <div class="header">
      <i></i>
      <p class="title">{{ 'termsOfUse.title' | translate }}</p>
    </div>
    <div class="content">
      <p class="title">{{ 'termsOfUse.pageTitle' | translate }}</p>
      <p class="subtitle">{{ 'termsOfUse.pageSubTitle' | translate }}</p>
      <div class="first-question">
        <p class="answer">{{ 'termsOfUse.firstQuestion.answer' | translate }}</p>
        <div class="indented">
          <p class="question">{{ 'termsOfUse.firstQuestion.question' | translate }}</p>
          <div>
            <p class="answer">{{ 'termsOfUse.firstQuestion.aAnswer' | translate }}</p>
            <p class="question">{{ 'termsOfUse.firstQuestion.aQuestion' | translate }}</p>
          </div>
          <div>
            <p class="answer">{{ 'termsOfUse.firstQuestion.bAnswer' | translate }}</p>
            <p class="question">{{ 'termsOfUse.firstQuestion.bQuestion' | translate }}</p>
          </div>
          <div>
            <p class="answer">{{ 'termsOfUse.firstQuestion.cAnswer' | translate }}</p>
            <p class="question">{{ 'termsOfUse.firstQuestion.cQuestion' | translate }}</p>
          </div>
          <div>
            <p class="answer">{{ 'termsOfUse.firstQuestion.dAnswer' | translate }}</p>
            <p class="question">{{ 'termsOfUse.firstQuestion.dQuestion' | translate }}</p>
          </div>
          <div>
            <p class="answer">{{ 'termsOfUse.firstQuestion.eAnswer' | translate }}</p>
            <p class="question">{{ 'termsOfUse.firstQuestion.eQuestion' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="third-question">
        <p class="answer">{{ 'termsOfUse.thirdQuestion.answer' | translate }}</p>
        <div class="indented">
          @for (answer of thirdAnswer; track answer) {
            <p class="question" [innerHTML]="answer"></p>
          }
        </div>
      </div>
      <div class="second-question">
        <p class="answer">{{ 'termsOfUse.secondQuestion.answer' | translate }}</p>
        <p class="question indented">{{ 'termsOfUse.secondQuestion.question' | translate }}</p>
      </div>
      <div class="third-question">
        <div class="indented">
          <p class="answer">{{ 'termsOfUse.fourthQuestion.answer' | translate }}</p>
          @for (answer of fourthAnswer; track answer) {
            <p class="question" [innerHTML]="answer"></p>
          }
        </div>
      </div>
      @for (answer of answers; track answer) {
        <div>
          <p class="answer">{{ answer.answer }}</p>
          <p class="question indented">{{ answer.question }}</p>
        </div>
      }
    </div>
  </div>
}
